import { useEffect, useState } from "react";
import { businessInfo, navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-[80px] md:h-[88px] flex items-center justify-between">
        <a href="#inicio" className="flex items-center cursor-pointer">
          <span className="flex items-center transition-colors duration-300">
            <img
              src={solid ? businessInfo.logo : businessInfo.logoWhite}
              alt="Laboratorio Clínico ANEDAN"
              title="Laboratorio Clínico ANEDAN"
              className="h-14 md:h-16 w-auto object-contain"
            />
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={businessInfo.phoneLink}
            className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-base"></i>
            Agenda tu cita
          </a>
        </div>

        <button
          type="button"
          aria-label="Abrir menú"
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-11 h-11 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
            solid ? "text-foreground-900 bg-background-100" : "text-background-50 bg-foreground-950/20"
          }`}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70 px-4 md:px-8 py-5 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="py-3 px-3 rounded-md text-foreground-800 font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href={businessInfo.phoneLink}
            className="mt-3 flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            Llamar al {businessInfo.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
}